import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "prev--sprite",
  "use": "prev--sprite-usage",
  "viewBox": "0 0 21 34",
  "content": "<symbol viewBox=\"0 0 21 34\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"prev--sprite\">\n<path d=\"M18.4234 2.31095L3.73438 17L18.4234 31.6891\" stroke-width=\"5\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol